import { render, staticRenderFns } from "./relay-point.component.vue?vue&type=template&id=7c665767&scoped=true&"
import script from "./relay-point.component.vue?vue&type=script&lang=ts&"
export * from "./relay-point.component.vue?vue&type=script&lang=ts&"
import style0 from "./relay-point.component.vue?vue&type=style&index=0&id=7c665767&scoped=true&lang=scss&"
import style1 from "./relay-point.component.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c665767",
  null
  
)

component.options.__file = "relay-point.component.vue"
export default component.exports